import React from "react";
import { useNavigate } from "react-router-dom";
import "../../css/homepage.css";
import { signUpMetamask } from "../../firebase/firebase";
import "../../css/homepage.css";

const Header = () => {
  const navigate = useNavigate();
  const connectWallet = async () => {
    const { isCreated, account } = await signUpMetamask();
    if (isCreated) {
      navigate("/dashboard", { state: { email: account } });
    } else {
      navigate("/setup", { state: { email: account } });
    }
  };
  return (
    <div className="flex justify-between px-10 py-5 ">
      <h1 className="flex-auto lg:text-4xl text-2xl font-bold text-transparent  font-Varela title">
        PAYTRON
      </h1>
      <div className="flex">
        <div>
          <button className="rounded-sm px-4 lg:py-4 bg-transparent docbutton">
            Documentation
          </button>
        </div>
        <div onClick={connectWallet}>
          <button className="rounded-sm px-4 py-1 lg:py-4 bg-transparent conbutton">
            Connect Wallet
          </button>
        </div>
      </div>
    </div>
  );
};

export default Header;
